module.exports = __webpack_public_path__ + "static/media/all-fp.bf43a96a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/all-fp.svg
// module id = 354
// module chunks = 7